export default {
  allFeedbackAssignedToMe(state, value) {
    state.allFeedbackAssignedToMe = value;
  },
  tableLoading(state, value) {
    state.tableLoading = value;
  },
  setSelectedRow(state, value) {
    state.selectedRow = value;
  },
  allFeedbackAppliedToMe(state, value) {
    state.allFeedbackAppliedToMe = value;
  },
};
